import { useEffect, useState } from 'react';

import BarraInferiorBotoes from '../../../../../../../components/BarraInferiorBotoes';
import BoxConteudo from '../../../../../../../components/BoxConteudo';
import CustomCol from '../../../../../../../components/CustomCol';
import CustomInputInt from '../../../../../../../components/CustomInputs/CustomInputInt';
import CustomInputText from '../../../../../../../components/CustomInputs/CustomInputText';
import CustomRow from '../../../../../../../components/CustomRow';
import CustomSelect from '../../../../../../../components/CustomSelects/CustomSelect';
import Input from '../../../../../../../components/InputNew';
import Log from '../../../../../../../components/Log/Log';
import Modal from '../../../../../../../components/Modal';
import WorkspaceBotoes from '../../../../../../../components/WorkspaceBotoes';
import WorkspaceFicha from '../../../../../../../components/WorkspaceFicha';
import { ICorRegistro } from '../../../../../../../modules/types/Cor';
import {
  IDominioForm,
  IDominioRegistro,
} from '../../../../../../../modules/types/Dominio';
import { getDominioById } from '../../../../../../../services/dominio/dominioService';
import theme from '../../../../../../../theme';
import { functionLogData } from '../../../../../../../utils/functionLogData';
import { handleDelete } from '../../../../../../../utils/handleDelete';
import { handleSave } from '../../../../../../../utils/handleSave';
import { swalAttention } from '../../../../../../../utils/swal';
import {
  camposAjustar,
  camposObrigatorios,
} from '../../../utils/camposObrigatoriosAjustar';
import { defaultFormMain } from '../../../utils/formDominioDefault';
import { optionCorText } from '../../../utils/optionCorText';
import { optionStatusBin } from '../../../utils/optionStatusBin';

export default function DominioSubtipoForm({
  idDominioTipo,
  show,
  onHide,
  novoDominioSubtipo,
  selectedId,
  allCores,
  optionsCores,
  recarregarDados,
  listaOrdemsExistentes,
  recarregarDadosPai,
}: {
  idDominioTipo: number;
  show: boolean;
  onHide: () => void;
  novoDominioSubtipo: boolean;
  selectedId: number | null;
  allCores: ICorRegistro[];
  optionsCores: { value: number; label: string }[];
  recarregarDados: () => void;
  listaOrdemsExistentes: number[];
  recarregarDadosPai: () => void;
}) {
  const [logData, setLogData] = useState<IDominioRegistro | null>(null);
  const [dataRaw, setDataRaw] = useState<IDominioForm | null>(null);

  //FORMULÁRIO
  const [formMain, setFormMain] = useState<IDominioForm>(defaultFormMain);

  const handleClearForm = () => {
    setFormMain(defaultFormMain);
    setLogData(null);
  };

  //Buscar dados
  const fetchData = async (id: string | number): Promise<void> => {
    try {
      const registroData: IDominioRegistro = await getDominioById(String(id));

      setLogData(registroData);

      const formValues: IDominioForm = {
        id: registroData.id,
        dominioPaiId: registroData.dominioPaiId,
        corId: Number(registroData.cor.id),
        corText: registroData.corText,
        status: registroData.status,
        ordem: registroData.ordem,
        nome: registroData.nome,
        descricao: registroData.descricao,
        observacoes: registroData.observacoes ?? '',
      };

      setFormMain(formValues);
      setDataRaw(formValues);
    } catch (error) {
      console.error('Erro ao obter dados:', error);
    }
  };
  useEffect(() => {
    if (show) {
      if (novoDominioSubtipo) {
        handleClearForm();
      } else if (selectedId) {
        fetchData(selectedId);
      }
    }
  }, [show, novoDominioSubtipo, selectedId]);

  const logs = functionLogData(logData);

  const handleChange = (
    event: React.ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >,
  ) => {
    const { name, value } = event.target;
    setFormMain((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleBlur = (
    event: React.FocusEvent<HTMLInputElement | HTMLSelectElement>,
  ) => {
    const { name, value } = event.target;

    if (name === 'ordem') {
      const ordemValue = Number(value);
      if (listaOrdemsExistentes.includes(ordemValue)) {
        swalAttention(
          `Ordem Nº <span style="font-weight:bold; background-color:yellow; padding:5px 15px; border-radius:4px; color:black">${ordemValue}</span> já existe.<br> Por favor, escolha um valor diferente.`,
        );

        setFormMain((prev) => ({ ...prev, ordem: 0 }));
      }
    }
  };

  const salvar = async () => {
    formMain.dominioPaiId = idDominioTipo;

    const result = await handleSave(
      formMain,
      camposObrigatorios,
      camposAjustar,
      'dominios',
      'daf/adm/dominios/dominio',
      fetchData,
      false,
      dataRaw,
    );

    await recarregarDados();
    await recarregarDadosPai();
  };

  //   console.log('FormMain:' + JSON.stringify(formMain));

  const deletar = async () => {
    const result = await handleDelete(Number(formMain.id), 'dominios');
    if (result) {
      await recarregarDados();
      await recarregarDadosPai();
      await onHide();
    }
  };

  return (
    <Modal open={show} onHide={onHide} tituloModal="Subtipo de Domínio">
      <WorkspaceFicha>
        {logs && <Log {...logs} entity="TB_DOMINIO_SUBTIPO" />}
        <BoxConteudo boxTitulo="Subtipo de Domínio">
          <CustomRow style={{ marginTop: '10px' }}>
            <CustomCol width="140px">
              <CustomSelect
                name="status"
                options={optionStatusBin}
                title="Status"
                value={formMain.status}
                onChange={handleChange}
                style={{
                  backgroundColor:
                    Number(formMain.status) === 2
                      ? theme.colors.vermelho
                      : Number(formMain.status) === 1
                        ? theme.colors.verde
                        : 'white',
                  color: Number(formMain.status) === 0 ? '#000000' : '#ffffff',
                }}
                required
              />
            </CustomCol>

            <CustomCol width="275px">
              <CustomSelect
                name="corId"
                options={optionsCores}
                title="Cor do Background"
                value={formMain.corId}
                onChange={handleChange}
                required
              />
            </CustomCol>
            <CustomCol width="150px">
              <CustomSelect
                name="corText"
                options={optionCorText}
                title="Cor do Texto"
                value={formMain.corText}
                onChange={handleChange}
                required
              />
            </CustomCol>
            <CustomCol></CustomCol>
          </CustomRow>
          <CustomRow>
            <CustomCol width="140px">
              <CustomInputInt
                name="ordem"
                title="Ordem"
                value={formMain.ordem}
                onChange={handleChange}
                onBlur={handleBlur}
                required
              />
            </CustomCol>
            <CustomCol>
              <CustomInputText
                name="nome"
                title="Nome do Subtipo de Domínio"
                value={formMain.nome}
                onChange={handleChange}
                required
                style={{
                  backgroundColor:
                    allCores.find((cor) => cor.id === Number(formMain.corId))
                      ?.codigoHexadecimal || '#ffffff',
                  color:
                    Number(formMain.corText) === 1
                      ? '#000000'
                      : Number(formMain.corText) === 2
                        ? '#ffffff'
                        : '#000000',
                }}
              />
            </CustomCol>
          </CustomRow>

          <CustomRow>
            <CustomCol>
              <CustomInputText
                name="descricao"
                value={formMain.descricao}
                title="Descrição"
                type="textArea"
                onChange={handleChange}
                rows={5}
                required
              />
            </CustomCol>
          </CustomRow>
          <CustomRow>
            <CustomCol>
              <CustomInputText
                name="observacoes"
                value={formMain.observacoes}
                title="Observações"
                type="textArea"
                onChange={handleChange}
                rows={3}
              />
            </CustomCol>
          </CustomRow>

          <BarraInferiorBotoes>
            {formMain.id !== 0 ? (
              <WorkspaceBotoes
                delete
                onClickDelete={deletar}
                save
                onClickSave={salvar}
              />
            ) : (
              <WorkspaceBotoes save onClickSave={salvar} />
            )}
          </BarraInferiorBotoes>
        </BoxConteudo>
      </WorkspaceFicha>
    </Modal>
  );
}
